import { push } from 'redux-first-history';

import {
  doSmsEnrollVerifyStart,
  doStartVerifyImprivataId,
  startLoading,
  setServerState,
  doLogout,
  doSecondFactorFailure,
  setTempCodeToManual,
  doStartVerifyNumberForImprivataId,
  doStartInitiateIdv,
  doStartWaitIdvResult,
  doLoginFailure,
  finishLoading,
  doSetInitialTempCode
} from './shared';
import { decideNextStep } from './decideNextStep';
import * as types from '../constants/cidraActions';
import {
  doInitiateIdv, doResendSms, doVerifyIcpFace
} from './authentication';
import {
  ChooseModalityProtocols,
  GetMessageProtocols
} from '../constants/clientProtocols';
import { storeAuthenticationState } from './resumeAuthSession';
import { getModalityOrder, SECONDFACTORONLY_WORKFLOW } from '../constants/workflowConstants';
import {
  initiateIdv, initiateImprivataIdPush, resendEmail, resendSms
} from './index';

export function chooseModality(serverState, isEnrollment, manuallyProceedToTempCode) {
  return function(dispatch, getState) {
    const {
      ModalIdOutOfBand,
      ModalImprivataId,
      ModalIdToken,
      ModalIdPassword,
      ModalEmailOtp,
      ModalImprivataPin,
      ModalAllowEligibility,
      ModalOutOfBandEnrollState,
      ModalOutOfBandAuthState,
      ModalOutOfBandAuthWaitManual,
      ModalEnrollmentState,
      ModalAuthState,
      ModalAuthStateTypeRequireManual,
      ModalTokenAuthState,
      ModalTokenAuthStateTypeIdTokenChallenge,
      ModalPasswordAuthState,
      ModalPasswordAuthStateTypeExpired,
      ModalPasswordAuthStateTypePassChangeOnLogin,
      ModalAuthStateTypeNumberMatching,
      ModalFace,
      ModalProxCard,
      ModalIdIdv,
      ModalIdvAuthState,
      ModalIdvAuthStateTypeIdvInitiated,
      ModalIdvAuthStateTypeIdvWaitForResult,
    } = ChooseModalityProtocols;

    if (manuallyProceedToTempCode && hasPreProvisionedTempCode(serverState) &&
      isStrongFactor(serverState.currentModality) ) {
      dispatch(captureAvailableModalities(serverState, manuallyProceedToTempCode) );
      dispatch(captureAuthenticatedModalities(serverState, manuallyProceedToTempCode) );
      dispatch(enterTempCodeFlow() );
    }
    else {
      dispatch(captureAvailableModalities(serverState, manuallyProceedToTempCode) );
      dispatch(captureAuthenticatedModalities(serverState, manuallyProceedToTempCode) );
      switch (serverState.currentModality) {
      case ModalIdOutOfBand.asString:
        if (isEnrollment) {
          const outOfBandState = ModalOutOfBandEnrollState.getValue(serverState.modalities.optionalOutOfBandEnrollmentState);
          const canSkipEnrollment = ModalAllowEligibility.asString ===
              outOfBandState.enrollmentEligibility;
          const canChangeEnrollmentModality = isAnotherEnrollmentModalityAvailable(serverState);

          let phoneNumber;
          if (outOfBandState.phoneNumber) {
            phoneNumber = outOfBandState.phoneNumber;
          }

          dispatch(push('/enrollsms') );
          if (phoneNumber) {
            dispatch(doSmsEnrollVerifyStart(phoneNumber) );
          }
          else {
            dispatch(doInputSmsEnroll(canSkipEnrollment, canChangeEnrollmentModality) );
          }
        }
        else {
          let lastFourDigits;
          const outOfBandState = ModalOutOfBandAuthState.getValue(serverState.modalities.optionalOutOfBandAuthenticationState);
          if (outOfBandState !== undefined) {
            switch (outOfBandState.outOfBandAuthenticationStateType) {
            case ModalOutOfBandAuthWaitManual:
              lastFourDigits = outOfBandState.tokens[0].phoneNumber;
              break;
            default:
              break;
            }
          }
          dispatch(doInputSms(lastFourDigits) );
          dispatch(push('/sms') );
        }
        break;
      case ModalImprivataId.asString:
        if (isEnrollment) {
          const iidEnrollmentState = ModalEnrollmentState.getValue(serverState.modalities.optionalImprivataIdEnrollmentState);
          const canSkipEnrollment = ModalAllowEligibility.asString === iidEnrollmentState.enrollmentEligibility;
          const canChangeEnrollmentModality = isAnotherEnrollmentModalityAvailable(serverState);
          dispatch(push('/enrollimprivataid') );
          dispatch(doInputIIDEnroll(canSkipEnrollment, canChangeEnrollmentModality) );
        }
        else {
          if (serverState.modalities.optionalImprivataIdAuthenticationState !== undefined) {
            const iidAuthState = ModalAuthState.getValue(serverState.modalities.optionalImprivataIdAuthenticationState);

            if (ModalAuthStateTypeRequireManual === iidAuthState.imprivataIdAuthenticationStateType) {
              dispatch(doInputImprivataIdManual(iidAuthState.deviceList) );
              dispatch(push('/iid-manual') );
            }
            else if (ModalAuthStateTypeNumberMatching === iidAuthState.imprivataIdAuthenticationStateType) {
              dispatch(doStartVerifyNumberForImprivataId(iidAuthState.authNumber, iidAuthState.deviceList) );
              dispatch(push('/iid') );
            }
            else {
              dispatch(doStartVerifyImprivataId(iidAuthState.deviceList) );
              dispatch(push('/iid') );
            }
          }
        }
        break;
      case ModalIdToken.asString:
        let challengeText;
        if (serverState.modalities.optionalIdTokenAuthenticationState !== undefined) {
          const idTokenData = ModalTokenAuthState.getValue(serverState.modalities.optionalIdTokenAuthenticationState);
          switch (idTokenData.idTokenAuthenticationStateType) {
          case ModalTokenAuthStateTypeIdTokenChallenge:
            challengeText = idTokenData.idTokenChallenge;
            break;
          default:
            break;
          }
        }
        dispatch(doInputOtp(challengeText) );
        dispatch(push('/otp') );
        break;
      case ModalIdPassword.asString:
        const passwordState = ModalPasswordAuthState.getValue(serverState.modalities.optionalPasswordAuthenticationState);
        if ([ModalPasswordAuthStateTypeExpired, ModalPasswordAuthStateTypePassChangeOnLogin,]
          .includes(passwordState.passwordAuthenticationStateType) ) {
          dispatch(doStartChangePassword() );
          dispatch(push('/password-reset') );
        }
        else {
          dispatch(doInputPassword() );
          dispatch(push('/password') );
        }
        break;
      case ModalEmailOtp.asString:
        dispatch(doInputEmail() );
        dispatch(push('/email') );
        break;
      case ModalImprivataPin.asString:
        dispatch(doInputPin() );
        dispatch(push('/pin') );
        break;
      case ModalFace.asString:
        if (getState().login.isCameraPresent === false) {
          // The device has no camera, so never route to the face screen again.
          // A pre-provisioned temp code takes precedence over the priority
          // fallback only when the fallback would be a strong factor (IID /
          // SMS / OTP / Email); otherwise let the user keep the stronger path.
          const decision = getFallbackModalityDecision(getState().login.availableModalities || [], 'face');
          if (manuallyProceedToTempCode && hasPreProvisionedTempCode(serverState) &&
            isStrongFactorFallback(decision) ) {
            dispatch(removeFaceModality() );
            dispatch(enterTempCodeFlow() );
          }
          else {
            dispatch(dispatchFallbackDecision(decision, 'face') );
          }
        }
        else {
          dispatch(doIcpFaceVerification(serverState.authContext.icpDomainSuffix, serverState.authContext.icpTenantId) );
          dispatch(push('/face?showVideo=true&contextType=idp-authn&resourceType=impr-eam-endpoint&icpApiDomainSuffix='
            + serverState.authContext.icpDomainSuffix) );
        }
        break;
      case ModalProxCard.asString:
        dispatch(doStartVerifyProxCard() );
        dispatch(push('/proxcard') );
        dispatch(finishLoading() );
        break;
      case ModalIdIdv.asString:
        const idvAuthState = ModalIdvAuthState.getValue(serverState.modalities.optionalIdvAuthenticationState);
        if (idvAuthState !== undefined) {
          switch (idvAuthState.idvAuthenticationStateType) {
          case ModalIdvAuthStateTypeIdvInitiated:
            dispatch(doStartInitiateIdv() );
            // A server without resume support sends no state token; storing then no-ops
            // so the redirect below still happens.
            dispatch(storeAuthenticationState(serverState.authContext?.stateToken) );
            window.location.href = idvAuthState.flowUrl;
            break;
          case ModalIdvAuthStateTypeIdvWaitForResult:
            dispatch(doStartWaitIdvResult() );
            dispatch(push('/idv') );
            break;
          default:
            dispatch(doStartInitiateIdv() );
            dispatch(doInitiateIdv() );
            break;
          }
        }
        break;
      default:
        break;
      }
    }
    return Promise.resolve();
  };
}

export function doInputTempCode() {
  return { type: types.INPUT_TEMPCODE, };
}

export function captureAvailableModalities(authenticationState) {
  return function(dispatch, getState) {
    const {
      ModalOutOfBandAuthState,
      ModalAuthState,
      ModalTokenAuthState,
      ModalPasswordAuthState,
      ModalFaceAuthState,
      ModalTokenAuthStateTypeModalityAuthAttempted,
      ModalIdAuthStateTypeModalityAuthAttempted,
      ModalPinAuthState,
      ModalPinAuthStateTypeModalityAuthAttempted,
      ModalOutOfBandAuthStateTypeModalityAuthAttempted,
      ModalPasswordAuthStateTypeModalityAuthAttempted,
      ModalFaceAuthStateTypeModalityAuthAttempted,
      ModalEmailAuthState,
      ModalEmailAuthStateTypeModalityAuthAttempted,
      ModalIdvAuthState,
      ModalIdvAuthStateTypeModalityAuthAttempted,
      ModalProxCardAuthState,
      ModalProxCardAuthStateTypeModalityAuthAttempted,
    } = ChooseModalityProtocols;

    const {
      modalities, temporaryCodeAvailable, temporaryCodeAllowed,
    } = authenticationState;
    const availableModalities = [];
    modalities.optionalIdTokenAuthenticationState &&
    !ModalTokenAuthState.isType(modalities.optionalIdTokenAuthenticationState, ModalTokenAuthStateTypeModalityAuthAttempted) &&
    availableModalities.push('otp');
    modalities.optionalImprivataIdAuthenticationState &&
    !ModalAuthState.isType(modalities.optionalImprivataIdAuthenticationState, ModalIdAuthStateTypeModalityAuthAttempted) &&
    availableModalities.push('iid');
    modalities.optionalImprivataPinAuthenticationState &&
    !ModalPinAuthState.isType(modalities.optionalImprivataPinAuthenticationState, ModalPinAuthStateTypeModalityAuthAttempted) &&
    availableModalities.push('pin');
    modalities.optionalEmailOtpAuthenticationState &&
    !ModalEmailAuthState.isType(modalities.optionalEmailOtpAuthenticationState, ModalEmailAuthStateTypeModalityAuthAttempted) &&
    availableModalities.push('email');
    modalities.optionalOutOfBandAuthenticationState &&
    !ModalOutOfBandAuthState.isType(modalities.optionalOutOfBandAuthenticationState, ModalOutOfBandAuthStateTypeModalityAuthAttempted) &&
    availableModalities.push('sms');
    modalities.optionalPasswordAuthenticationState &&
    !ModalPasswordAuthState.isType(modalities.optionalPasswordAuthenticationState, ModalPasswordAuthStateTypeModalityAuthAttempted) &&
    availableModalities.push('password');
    modalities.optionalFaceAuthenticationState &&
    getState().login.isCameraPresent !== false &&
    !ModalFaceAuthState.isType(modalities.optionalFaceAuthenticationState, ModalFaceAuthStateTypeModalityAuthAttempted) &&
    availableModalities.push('face');
    modalities.optionalIdvAuthenticationState &&
    !ModalIdvAuthState.isType(modalities.optionalIdvAuthenticationState, ModalIdvAuthStateTypeModalityAuthAttempted) &&
    availableModalities.push('idv');
    modalities.optionalProxCardAuthenticationState &&
    getState().login.proxReaderConnected !== false &&
    !ModalProxCardAuthState.isType(modalities.optionalProxCardAuthenticationState, ModalProxCardAuthStateTypeModalityAuthAttempted) &&
    availableModalities.push('proxcard');
    temporaryCodeAllowed && temporaryCodeAvailable &&
    availableModalities.push('tempcode');

    dispatch(setAvailableModalities(availableModalities) );
  };
}

export function captureAuthenticatedModalities(authenticationState) {
  return function(dispatch) {
    const {
      ModalOutOfBandAuthState,
      ModalAuthState,
      ModalTokenAuthState,
      ModalPasswordAuthState,
      ModalFaceAuthState,
      ModalTokenAuthStateTypeModalityAuthAttempted,
      ModalIdAuthStateTypeModalityAuthAttempted,
      ModalPinAuthState,
      ModalPinAuthStateTypeModalityAuthAttempted,
      ModalOutOfBandAuthStateTypeModalityAuthAttempted,
      ModalPasswordAuthStateTypeModalityAuthAttempted,
      ModalFaceAuthStateTypeModalityAuthAttempted,
      ModalEmailAuthState,
      ModalEmailAuthStateTypeModalityAuthAttempted,
      ModalIdvAuthState,
      ModalIdvAuthStateTypeModalityAuthAttempted,
      ModalProxCardAuthState,
      ModalProxCardAuthStateTypeModalityAuthAttempted,
    } = ChooseModalityProtocols;

    const { modalities, } = authenticationState;
    const authenticatedModalities = [];
    modalities.optionalIdTokenAuthenticationState &&
    ModalTokenAuthState.isType(modalities.optionalIdTokenAuthenticationState, ModalTokenAuthStateTypeModalityAuthAttempted) &&
    authenticatedModalities.push('otp');
    modalities.optionalImprivataIdAuthenticationState &&
    ModalAuthState.isType(modalities.optionalImprivataIdAuthenticationState, ModalIdAuthStateTypeModalityAuthAttempted) &&
    authenticatedModalities.push('iid');
    modalities.optionalImprivataPinAuthenticationState &&
    ModalPinAuthState.isType(modalities.optionalImprivataPinAuthenticationState, ModalPinAuthStateTypeModalityAuthAttempted) &&
    authenticatedModalities.push('pin');
    modalities.optionalEmailOtpAuthenticationState &&
    ModalEmailAuthState.isType(modalities.optionalEmailOtpAuthenticationState, ModalEmailAuthStateTypeModalityAuthAttempted) &&
    authenticatedModalities.push('email');
    modalities.optionalOutOfBandAuthenticationState &&
    ModalOutOfBandAuthState.isType(modalities.optionalOutOfBandAuthenticationState, ModalOutOfBandAuthStateTypeModalityAuthAttempted) &&
    authenticatedModalities.push('sms');
    modalities.optionalPasswordAuthenticationState &&
    ModalPasswordAuthState.isType(modalities.optionalPasswordAuthenticationState, ModalPasswordAuthStateTypeModalityAuthAttempted) &&
    authenticatedModalities.push('password');
    modalities.optionalFaceAuthenticationState &&
    ModalFaceAuthState.isType(modalities.optionalFaceAuthenticationState, ModalFaceAuthStateTypeModalityAuthAttempted) &&
    authenticatedModalities.push('face');
    modalities.optionalIdvAuthenticationState &&
    ModalIdvAuthState.isType(modalities.optionalIdvAuthenticationState, ModalIdvAuthStateTypeModalityAuthAttempted) &&
    authenticatedModalities.push('idv');
    modalities.optionalProxCardAuthenticationState &&
    ModalProxCardAuthState.isType(modalities.optionalProxCardAuthenticationState, ModalProxCardAuthStateTypeModalityAuthAttempted) &&
    authenticatedModalities.push('proxcard');
    dispatch(setAuthenticatedModalities(authenticatedModalities) );
  };
}

function isAnotherEnrollmentModalityAvailable(authState) {
  const { optionalOutOfBandEnrollmentState, optionalImprivataIdEnrollmentState, } = authState.modalities;

  const {
    ModalImprivataId,
    ModalOutOfBandEnrollState,
    ModalEnrollmentState,
    ModalOutOfBandEnrollStateTypeEnrollNotAttempted,
    ModalIdEnrollmentStateTypeModalityEnrollNotAttempted,
    ModalIdOutOfBand,
  } = ChooseModalityProtocols;

  switch (authState.currentModality) {
  case ModalImprivataId.asString:
    return Boolean(optionalOutOfBandEnrollmentState &&
        ModalOutOfBandEnrollState.isType(optionalOutOfBandEnrollmentState, ModalOutOfBandEnrollStateTypeEnrollNotAttempted) );
  case ModalIdOutOfBand.asString:
    // falls through
  default:
    return Boolean(optionalImprivataIdEnrollmentState &&
        ModalEnrollmentState.isType(optionalImprivataIdEnrollmentState, ModalIdEnrollmentStateTypeModalityEnrollNotAttempted) );
  }
}

export function doInputIIDEnroll(canSkipEnrollment, canChangeEnrollmentModality) {
  return {
    type: types.INPUT_IMPRIVATA_ID_ENROLL,
    canSkipEnrollment,
    canChangeEnrollmentModality,
  };
}

export function doInputSmsEnroll(canSkipEnrollment, canChangeEnrollmentModality) {
  return {
    type: types.INPUT_SMS_ENROLL,
    canSkipEnrollment,
    canChangeEnrollmentModality,
  };
}

export function doInputSms(lastFourDigits) {
  return {
    lastFourDigits,
    type: types.INPUT_SMS,
  };
}

export function doInputImprivataIdManual(deviceList = []) {
  return {
    deviceList,
    type: types.INPUT_IMPRIVATA_ID_MANUAL,
  };
}

export function doInputOtp(challengeText) {
  return {
    type: types.INPUT_OTP,
    challengeText,
  };
}

export function doInputEmail() {
  return { type: types.INPUT_EMAIL, };
}

export function doStartChangePassword() {
  return { type: types.START_CHANGE_PASSWORD, };
}

export function doInputPassword() {
  return { type: types.INPUT_PASSWORD, };
}

export function doInputPin() {
  return { type: types.INPUT_PIN, };
}

export function doIcpFaceVerification(icpDomainSuffix, icpTenantId) {
  return {
    type: types.INIT_FACE,
    icpDomainSuffix,
    icpTenantId,
  };
}

function doStartVerifyProxCard() {
  return { type: types.START_VERIFY_PROX_CARD, };
}

export function setAvailableModalities(availableModalities) {
  return {
    availableModalities,
    type: types.SET_AVAILABLE_MODALITIES,
  };
}

export function setAuthenticatedModalities(authenticatedModalities) {
  return {
    authenticatedModalities,
    type: types.SET_AUTHENTICATED_MODALITIES,
  };
}

export function setChooseModality(moreOptionsChooseModality) {
  return {
    type: types.SET_IS_FROM_MORE_OPTIONS_LINK,
    moreOptionsChooseModality,
  };
}

export function removeFaceModality() {
  return { type: types.REMOVE_FACE_MODALITY, };
}

export const ModalityFallbackDecision = {
  NONE: 'none',
  LOGOUT: 'logout',
  CHOOSE_MODALITY: 'choose-modality',
  FALLBACK: 'fallback',
};

// Deprecated alias kept for backward compatibility; prefer ModalityFallbackDecision.
export const NoCameraDecision = ModalityFallbackDecision;

/**
 * Picks the modality to fall back to when `modalityToRemove` cannot be used,
 * ignoring that modality and tempcode, preferring the highest-priority modality.
 * @param {Array} availableModalities
 * @param {string} modalityToRemove
 * @returns {{type: string, targetModality?: string}}
 */
function getFallbackModalityDecision(availableModalities, modalityToRemove) {
  const remaining = availableModalities
    .filter(m => m !== modalityToRemove && m !== 'tempcode')
    .sort( (a, b) => getModalityOrder(a) - getModalityOrder(b) );
  if (remaining.length === 0) {
    return { type: ModalityFallbackDecision.LOGOUT, };
  }
  const targetModality = remaining[0];
  if (getModalityId(targetModality) === null) {
    return { type: ModalityFallbackDecision.CHOOSE_MODALITY, };
  }
  return {
    type: ModalityFallbackDecision.FALLBACK,
    targetModality,
  };
}

/**
 * Returns the next modality to fall back to when `modalityToRemove` is not available.
 * @param {Array} availableModalities
 * @param {string} modalityToRemove
 * @returns {{type: string, targetModality?: string}}
 */
export function getModalityUnavailableDecision(availableModalities = [], modalityToRemove) {
  if (!availableModalities.includes(modalityToRemove) ) {
    return { type: ModalityFallbackDecision.NONE, };
  }
  return getFallbackModalityDecision(availableModalities, modalityToRemove);
}

/**
 * Returns the next modality to fall back to when Face is not available.
 * @param {Array} availableModalities
 * @returns {{type: string, targetModality?: string}}
 */
export function getNoCameraOnDeviceDecision(availableModalities = []) {
  return getModalityUnavailableDecision(availableModalities, 'face');
}

/**
 * Routes the user based on a fallback decision: switch to another modality
 * (initiating it on the server), let the user choose, or log out.
 * @param {{type: string, targetModality?: string}} decision
 * @param {string} fromModality - the modality that became unavailable
 */
function dispatchFallbackDecision(decision, fromModality) {
  return function(dispatch, getState) {
    switch (decision.type) {
    case ModalityFallbackDecision.LOGOUT: {
      const { GetMsgWorkflowNotAllowed, GetMsgModalityNotAllowed, } = GetMessageProtocols;
      const {
        isEpcsWorkflow, optionalWorkflowName, isWebSsoWorkflow,
      } = getState().login;
      const error = isEpcsWorkflow || optionalWorkflowName === SECONDFACTORONLY_WORKFLOW
        ? GetMsgWorkflowNotAllowed.asString
        : GetMsgModalityNotAllowed.asString;
      if (fromModality === 'face') {
        // send empty verification code to fail authentication flow and audit failure in EAM server.
        // Capture isWebSsoWorkflow at construction time because doVerifyIcpFace dispatches
        // doLogout() before dispatching the failure thunk, which would wipe the flag from state.
        dispatch(doVerifyIcpFace('', doLoginFailure(error, isWebSsoWorkflow) ) );
      }
      break;
    }
    case ModalityFallbackDecision.CHOOSE_MODALITY:
      dispatch(setChooseModality(true) );
      dispatch(push('/choosemodality') );
      break;
    case ModalityFallbackDecision.FALLBACK:
      // Switch through the appliance so modalities that require server-side
      // initiation (e.g. sms, iid) are started correctly.
      dispatch(doChangeModality(fromModality, decision.targetModality) );
      break;
    default:
      break;
    }
  };
}

/**
 * Generic handler for a modality becoming unavailable (e.g. no camera, reader
 * disconnected). Removes the modality from the available list, and when
 * `switchToAnotherModality` is set, either preempts to a pre-provisioned temp
 * code or falls back to the next available modality based on priority.
 * @param {string} modalityToRemove
 * @param {boolean} switchToAnotherModality
 * @param {function} removeModalityAction - action creator dispatched to remove the modality from state
 */
export function handleModalityUnavailable(modalityToRemove, switchToAnotherModality, removeModalityAction) {
  return function(dispatch, getState) {
    if (switchToAnotherModality) {
      const { availableModalities, serverState, } = getState().login;
      const decision = getModalityUnavailableDecision(availableModalities || [], modalityToRemove);
      switch (decision.type) {
      case ModalityFallbackDecision.NONE:
        break;
      default:
        // Preempt to a pre-provisioned temp code only when the fallback would be
        // a strong factor (IID / SMS / OTP / Email); otherwise the user keeps
        // the stronger fallback path instead of being switched to temp code.
        if (hasPreProvisionedTempCode(serverState) && isStrongFactorFallback(decision) ) {
          dispatch(removeModalityAction() );
          dispatch(enterTempCodeFlow() );
        }
        else {
          dispatch(removeModalityAction() );
          dispatch(dispatchFallbackDecision(decision, modalityToRemove) );
        }
        break;
      }
    }
    else {
      dispatch(removeModalityAction() );
    }
  };
}

/**
 * Handles the case where the user's device does not have a camera.
 * If the server supports the excludeModality capability, asks it to exclude
 * face and decide the next step; otherwise falls back to the client-side
 * priority fallback (redirect to the next available modality, temp code, or
 * choose-modality/logout) based on the remaining available modalities.
 */
export function handleNoCameraOnDevice(switchToAnotherModality) {
  return function(dispatch, getState) {
    const { capabilities, isCameraPresent, } = getState().login;
    if (isCameraPresent) {
      const modality = 'face';
      const supportsExcludeModality = capabilities?.CommonAuthenticationUI?.some(
        capability => capability.capabilityName === 'excludeModality');
      if (switchToAnotherModality && supportsExcludeModality) {
        dispatch(doExcludeModality(modality, removeFaceModality) );
      }
      else {
        dispatch(handleModalityUnavailable(modality, switchToAnotherModality, removeFaceModality) );
      }
    }
  };
}

function hasPreProvisionedTempCode(serverState) {
  return Boolean(serverState &&
    serverState.temporaryCodeAllowed &&
    serverState.temporaryCodeAvailable);
}

function isStrongFactorFallback(decision) {
  if (decision.type !== NoCameraDecision.FALLBACK) {
    return false;
  }
  const modalityId = getModalityId(decision.targetModality);
  return modalityId !== null && isStrongFactor(modalityId.asString);
}

function enterTempCodeFlow() {
  return function(dispatch) {
    dispatch(doInputTempCode() );
    dispatch(push('/tempcode') );
  };
}

function isStrongFactor(modalityId) {
  const {
    ModalIdOutOfBand,
    ModalImprivataId,
    ModalIdToken,
    ModalEmailOtp,
  } = ChooseModalityProtocols;

  console.log("" & modalityId); // eslint-disable-line

  const strongFactors = [
    ModalImprivataId.asString,
    ModalIdOutOfBand.asString,
    ModalIdToken.asString,
    ModalEmailOtp.asString,
  ];

  return strongFactors.includes(modalityId);
}

export function shouldPreemptToTempCode(authState) {
  return hasPreProvisionedTempCode(authState) && isStrongFactor(authState && authState.currentModality);
}

export function doChangeEnrollModality(modality) {
  return function(dispatch, getState) {
    const { ModalEnrollModalityChange, } = ChooseModalityProtocols;
    const { authClient, oneSignSessionId, } = getState().login;
    const modalityId = getModalityId(modality);
    dispatch(startLoading() );
    const changeModality = new ModalEnrollModalityChange(oneSignSessionId, modalityId.asString);
    return authClient.sendRequest(changeModality).then(response => {
      const serverState = response.message;
      dispatch(setServerState(serverState) );
      if (serverState.errorCode) {
        dispatch(doLogout() );
        dispatch(doSecondFactorFailure(serverState.errorCode) );
      }
      else {
        dispatch(decideNextStep(serverState, false) );
      }
    });
  };
}

export function doChangeModality(fromModality, toModality) {
  return function(dispatch, getState) {
    const { ModalAuthChangeModality, ModalResponseAuthErrorContinued, } = ChooseModalityProtocols;
    const {
      serverState, authClient, oneSignSessionId, isDeviceManagementWorkflow,
    } = getState().login;
    dispatch(startLoading() );
    if (fromModality === 'tempcode') {
      dispatch(setTempCodeToManual() );
    }
    // HT-2168 This should be addressed in an appliance change in the future ////////////////
    if (fromModality === 'sms' && toModality === 'sms') {
      dispatch(doResendSms() );
      dispatch(chooseModality(serverState) );
      return Promise.resolve();
    }
    if (fromModality === 'otp' && toModality === 'otp') {
      dispatch(chooseModality(serverState) );
      return Promise.resolve();
    }
    if (fromModality === 'face' && toModality === 'face') {
      dispatch(chooseModality(serverState) );
      return Promise.resolve();
    }
    // ///////////////////////////////////////////////////////////////////////////////////////
    if (toModality === 'tempcode') {
      dispatch(chooseModality(serverState, !isDeviceManagementWorkflow, true) );
      return Promise.resolve();
    }
    else {
      const modalityId = getModalityId(toModality);
      const changeModality = new ModalAuthChangeModality(oneSignSessionId, modalityId.asString);
      return authClient.sendRequest(changeModality).then(response => {
        const serverState = response.message;

        dispatch(setServerState(serverState) );
        if (serverState.errorCode && serverState.responseType !== ModalResponseAuthErrorContinued) {
          dispatch(doLogout() );
          dispatch(doSecondFactorFailure(serverState.errorCode) );
        }
        else {
          dispatch(decideNextStep(serverState, false) );
        }
      });
    }
  };
}

export function doExcludeModality(modalityToExclude, removeModalityAction) {
  return function(dispatch, getState) {
    const { ModalAuthExcludeModality, } = ChooseModalityProtocols;
    const { GetMsgWorkflowNotAllowed, } = GetMessageProtocols;
    const {
      authClient, oneSignSessionId, isEntraIdEamIntegration,
    } = getState().login;
    if (modalityToExclude === 'proxcard' || modalityToExclude === 'face') {
      dispatch(removeModalityAction() );
      const excludeInBackground =
        document.location.pathname !== '/proxcard' && document.location.pathname !== '/face';
      if (!excludeInBackground) {
        dispatch(startLoading() );
      }
      const modalityId = getModalityId(modalityToExclude);
      const excludeModality = new ModalAuthExcludeModality(oneSignSessionId, modalityId.asString);
      return authClient.sendRequest(excludeModality).then(response => {
        const serverState = response.message;

        dispatch(setServerState(serverState) );
        if (serverState.errorCode) {
          // change the error code for EntraId Eam Integration to show correct error.
          const errorCode = isEntraIdEamIntegration ? GetMsgWorkflowNotAllowed.asString : serverState.errorCode;
          dispatch(doLogout() );
          dispatch(doLoginFailure(errorCode, false) );
        }
        else {
          if (!excludeInBackground) {
            if (shouldPreemptToTempCode(serverState) ) {
              dispatch(doSetInitialTempCode(true) );
              dispatch(decideNextStep(serverState, false) );
              return;
            }
            dispatch(doInitiateModality(serverState) );
          }
        }
      });
    }
    else {
      dispatch(finishLoading() );
      return Promise.resolve();
    }
  };
}

export function doInitiateModality(serverState) {
  return function(dispatch) {
    const {
      ModalImprivataId, ModalIdOutOfBand, ModalEmailOtp, ModalIdIdv,
    } = ChooseModalityProtocols;
    switch (serverState.currentModality) {
    case ModalImprivataId.asString:
      dispatch(initiateImprivataIdPush() );
      break;
    case ModalIdOutOfBand.asString:
      dispatch(resendSms() );
      break;
    case ModalEmailOtp.asString:
      dispatch(resendEmail() );
      break;
    case ModalIdIdv.asString:
      dispatch(initiateIdv() );
      break;
    default:
      dispatch(decideNextStep(serverState, false) );
    }
  };
}

function getModalityId(modalityString) {
  const {
    ModalIdOutOfBand,
    ModalImprivataId,
    ModalIdToken,
    ModalIdPassword,
    ModalEmailOtp,
    ModalImprivataPin,
    ModalFace,
    ModalIdIdv,
    ModalIdProxCard,
  } = ChooseModalityProtocols;

  switch (modalityString) {
  case 'iid':
    return ModalImprivataId;
  case 'sms':
    return ModalIdOutOfBand;
  case 'otp':
    return ModalIdToken;
  case 'email':
    return ModalEmailOtp;
  case 'password':
    return ModalIdPassword;
  case 'pin':
    return ModalImprivataPin;
  case 'face':
    return ModalFace;
  case 'idv':
    return ModalIdIdv;
  case 'proxcard':
    return ModalIdProxCard;
    // tests ! returning null will break the code at line 314
  default:
    return null;
  }
}
